/* eslint-disable no-underscore-dangle */
import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {withResizeDetector} from 'react-resize-detector';
import Select from 'react-select';

import Steve from '@gluenetworks/steve_core';
import {steveDataStorage} from '../../../../helpers/sdk-helpers';

import {Formik, Field, Form, ErrorMessage} from 'formik';
/* Helpers */
import {
  maxLength,
  minLength,
  required,
  schemaValidate,
} from '../../../../helpers/validation-helpers';
import TuiCalendar from 'tui-calendar';
import 'tui-calendar/dist/tui-calendar.css';
import moment from 'moment';
import {
  getSchedulesStart,
  getFutureSchedulesStart,
  getPastSchedulesStart,
} from '../../../../store/dashboard/dashboard-actions';

// If you use the default popups, use this.
// import 'tui-date-picker/dist/tui-date-picker.css';
// import 'tui-time-picker/dist/tui-time-picker.css';

/* Components */
import ModalDefault from '../../../common/modal/modal-default';
import IconButton from '../../../common/icon-button/icon-button';
import Input from '../../../common/form-elements/input/input';
import FormErrorMessage from '../../../common/form-elements/form-error-message/form-error-message';
import WidgetOptions from '../widget-options/widget-options';
import Loader from '../../../common/loader/Loader';
import WidgetEmpty from '../empty-widget-content/empty-widget-content';
import TextOverflowTooltip from '../../../common/TextOverflowTooltip';
/* Styles */
import './scheduled-activity.scss';
/* Constants */
import {calendarCardTheme, viewType, workType, CUSTOM_THEME, Statuses} from './scheduler-constants';
import {SCHEDULE_TYPES} from '../../../../pagingfeed/column-helpers/scheduleConstants';

const calendarOptions = {
  // sort of option properties.
  taskView: false,
  scheduleView: ['time'],
  daynames: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  isReadOnly: true,
  disableClick: true,
};

// eslint-disable-next-line max-len
const dateTimeRegex =
  /(20[0-9]{2}\/(3[0-1]|([1-2][0-9])|(0?[1-9]))\/(3[0-1]|([1-2][0-9])|(0?[1-9]))|(3[0-1]|([1-2][0-9]))|(3[0-1]|([1-2][0-9])|(0?[1-9]))\/(3[0-1]|([1-2][0-9])|(0?[1-9]))\/20[0-9]{2}) (2[0-3]|[1][0-9]|0?[0-9])(:|.)[0-5][0-9]((:|.)[0-5][0-9])?( ?AM| ?PM)?$/i;

class ScheduledActivityWidget extends React.PureComponent {
  constructor(props) {
    super(props);
    this.isScheduleMounted = false;
    this.justMounted = true;
    const {workType: workTypeFromUD} = this.props.data.config;
    const {viewType: viewTypeFromUD} = this.props.data.config;

    this.viewTypePref = steveDataStorage('dashboards', 'running', true).get(
      `schedulePref-${this.props.data.id}`
    );

    this.state = {
      isSettingsModalShown: false,
      viewType: this.viewTypePref || viewTypeFromUD || {value: 'day', label: 'Daily'},
      workType: workTypeFromUD || {value: 'all', label: 'All'},
    };
    this.runningSchedules = [];
    this.componentShutDown = false;
    this.rootEl = React.createRef();
    this.calendarRef = React.createRef();
    this.moveNavigation = React.createRef();
    this.renderRange = React.createRef();
    this.steve = Steve.getInstance();
  }

  registerEntityChangeFeedListeners() {
    this.props.schedulesFeed.addListener(
      'EntityAdded',
      (this.onEntityAdded = this.onEntityAdded.bind(this))
    );
    this.props.schedulesFeed.addListener(
      'EntityPropertiesUpdated',
      (this.onEntityUpdated = this.onEntityUpdated.bind(this))
    );
    this.props.schedulesFeed.addListener(
      'EntityRemoved',
      (this.onEntityRemoved = this.onEntityRemoved.bind(this))
    );
  }

  unregisterEntityChangeFeedListeners() {
    if (
      this.props.schedulesFeed &&
      typeof this.props.schedulesFeed.removeAllListeners === 'function'
    ) {
      this.props.schedulesFeed.removeAllListeners('EntityAdded');
      this.props.schedulesFeed.removeAllListeners('EntityPropertiesUpdated');
      this.props.schedulesFeed.removeAllListeners('EntityRemoved');
    }
    document.removeEventListener('click', this.editClicked);
  }

  onEntityAdded(triggerTypeEntity) {
    this.addSchedule(triggerTypeEntity);
  }

  onEntityUpdated(triggerTypeEntity) {
    this.updateSchedule(triggerTypeEntity);
  }

  onEntityRemoved(triggerTypeEntity) {
    if (this.props.schedulesFeed.getStatus() === 'INITIALIZED') {
      this.removeSchedule(triggerTypeEntity);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.isScheduleMounted) {
      if (
        !prevProps.schedulesFeed.hasOwnProperty('_cache') ||
        this.justMounted ||
        (Object.keys(prevProps.schedulesFeed).length > 0 &&
          typeof this.props.schedulesFeed.getCache === 'function' &&
          Object.keys(prevProps.schedulesFeed.getCache()).length !==
            Object.keys(this.props.schedulesFeed.getCache()).length)
      ) {
        if (Object.keys(this.props.schedulesFeed).length > 0) {
          this.justMounted = false;
          this.registerEntityChangeFeedListeners();
          this.createSchedule(this.props.schedulesFeed);
        }
      }
      const futureFeed = this.props.futureSchedulesFeed;

      if (futureFeed && futureFeed.length > 0 && this.props.schedulesFeed) {
        this.createFutureSchedule(this.props.futureSchedulesFeed);
      }

      const pastFeed = this.props.pastSchedulesFeed;

      if (pastFeed && pastFeed.length > 0 && this.props.schedulesFeed) {
        this.createPastSchedule(this.props.pastSchedulesFeed);
      }

      this.toggleCalendarViews();
    }
  }

  createRecurranceString(every, type) {
    switch (type) {
      case 'one':
        return SCHEDULE_TYPES.one.title;
      case 'poll':
        if (every.hour > 1) {
          return `Every ${every.hour} hours`;
        }
        return SCHEDULE_TYPES.poll.title;
      case 'day':
        if (every > 1) {
          return `Every ${every} days`;
        }
        return SCHEDULE_TYPES.day.title;
      case 'dow':
        if (every > 1) {
          return `Every ${every} weeks on day(s) of the week`;
        }
        return SCHEDULE_TYPES.dow.title;
      case 'dom':
        if (every > 1) {
          return `Every ${every} months on day(s)`;
        }
        return SCHEDULE_TYPES.dom.title;
      case 'dowom':
        if (every > 1) {
          return `Every ${every} months on day(s) of the week`;
        }
        return SCHEDULE_TYPES.dowom.title;
      case 'domoy':
        if (every > 1) {
          return `Every ${every} years on a date of a month`;
        }
        return SCHEDULE_TYPES.domoy.title;
      case 'dowomoy':
        if (every > 1) {
          return `Every ${every} years on day(s) of a month`;
        }
        return SCHEDULE_TYPES.dowomoy.title;
      default:
        return SCHEDULE_TYPES.unknown.title;
    }
  }

  async createFutureSchedule(futureFeed) {
    const mainSchedule = this.props.schedulesFeed.getCache();

    const futureSchedules = futureFeed;
    const futureScheduleIds = [];
    const regex = /( - | scheduled on )(.+)$/;
    if (mainSchedule) {
      futureSchedules.forEach((futureSchedule) => {
        const trigger = mainSchedule[futureSchedule.getTriggerTypeId()].getPristineProperties();

        const startTime = new Date(futureSchedule.getPristineProperties().expectedExecutionTime);
        let approximateMinutes = 0;
        if (
          this.props.pastSchedulesFeed.length > 0 &&
          this.props.pastSchedulesFeed.filter(
            (a) => a.getTriggerTypeId() === futureSchedule.getTriggerTypeId()
          ).length > 0
        ) {
          const lastTrigger = this.props.pastSchedulesFeed
            .filter((a) => a.getTriggerTypeId() === futureSchedule.getTriggerTypeId())
            .slice(-1)[0];
          const duration = moment.duration(
            moment(lastTrigger.getCompletionTime()).diff(
              moment(lastTrigger.getActualExecutionTime())
            )
          );
          approximateMinutes = duration.asMinutes();
        }

        const endTime = moment(startTime)
          .add(approximateMinutes > 30 ? approximateMinutes : 30, 'm')
          .toDate();
        futureScheduleIds.push(futureSchedule.getId());

        let displayName = trigger.displayName;
        if (regex.test(trigger.displayName)) {
          const secondPart = displayName.match(regex, '$2')[
            displayName.match(regex, '$2').length - 1
          ];
          const isValidDateInTitle = dateTimeRegex.test(secondPart);
          if (isValidDateInTitle) {
            displayName = trigger.displayName.replace(regex, '');
          }
        }

        // eslint-disable-next-line max-len
        const targets =
          trigger.workTarget.hasOwnProperty('ids') &&
          trigger.workTarget.hasOwnProperty('entityType')
            ? // eslint-disable-next-line max-len
              `(${trigger.workTarget.ids.length} ${trigger.workTarget.entityType.toLowerCase()}${
                trigger.workTarget.ids.length === 1 ? '' : 's'
              })`
            : '';
        const currentSchedule = {
          id: futureSchedule.getId(),
          calendarId: trigger.workType,
          // eslint-disable-next-line max-len
          title: `${displayName}
                        ${targets}`,
          category: 'time',
          dueDateClass: '',
          start: startTime,
          end: endTime,
          isReadOnly: true,
          isVisible: true,
          recurrenceRule: trigger.schedule.every
            ? this.createRecurranceString(trigger.schedule.every, trigger.schedule.type)
            : null,
          body: mainSchedule[futureSchedule.getTriggerTypeId()].id,
        };
        if (!this.calendarInst.getSchedule(currentSchedule.id, currentSchedule.calendarId)) {
          this.calendarInst.createSchedules([currentSchedule], true);
        } else {
          this.calendarInst.updateSchedule(
            currentSchedule.id,
            currentSchedule.calendarId,
            currentSchedule,
            true
          );
        }
      });
    }

    if (this.state.workType.value === 'all') {
      Object.keys(calendarCardTheme).forEach((calendarId) => {
        this.calendarInst.toggleSchedules(calendarId, false, true);
      });
    } else {
      Object.keys(calendarCardTheme).forEach((calendarId) => {
        this.calendarInst.toggleSchedules(calendarId, true, true);
      });
      this.calendarInst.toggleSchedules(this.state.workType.value, false, true);
    }

    this.calendarInst.render(true);
  }

  async createPastSchedule(pastFeed) {
    const mainSchedule = this.props.schedulesFeed.getCache();

    const pastSchedules = pastFeed;
    const pastScheduleIds = [];
    const regex = /( - | scheduled on )(.+)$/;

    if (mainSchedule) {
      pastSchedules.forEach((pastSchedule) => {
        const trigger = mainSchedule[pastSchedule.getTriggerTypeId()].getPristineProperties();
        const pastScheduleProps = pastSchedule.getPristineProperties();
        const startTime = new Date(pastScheduleProps.expectedExecutionTime);
        const endTime = new Date(
          pastScheduleProps.completionTime || moment(startTime).add(60, 'm').toDate()
        );

        let status = Statuses[pastScheduleProps.status];
        if (pastScheduleProps.status === 'FAILED') {
          status = Statuses.FAILED;
        } else if (pastScheduleProps.targetCount === pastScheduleProps.successCount) {
          status = Statuses.SUCCESSFUL;
        } else if (pastScheduleProps.status === 'RUNNING') {
          status = `Running (${Math.floor(
            ((pastScheduleProps.successCount + pastScheduleProps.failureCount) /
              pastScheduleProps.targetCount) *
              100
          )}%)`;
        } else if (pastScheduleProps.successCount === 0) {
          status = Statuses.FAILED;
        } else {
          status = `${Math.floor(
            (pastScheduleProps.successCount / pastScheduleProps.targetCount) * 100
          )}%
                    ${Statuses.SUCCESSFUL}`;
        }

        let displayName = trigger.displayName;
        if (regex.test(trigger.displayName)) {
          const secondPart = displayName.match(regex, '$2')[
            displayName.match(regex, '$2').length - 1
          ];
          const isValidDateInTitle = dateTimeRegex.test(secondPart);
          if (isValidDateInTitle) {
            displayName = trigger.displayName.replace(regex, '');
          }
        }
        let recurringRule = null;
        if (trigger.schedule.every) {
          recurringRule = this.createRecurranceString(
            trigger.schedule.every,
            trigger.schedule.type
          );
        }
        pastScheduleIds.push(pastSchedule.getId());
        // eslint-disable-next-line max-len
        const targets =
          trigger.workTarget.hasOwnProperty('ids') &&
          trigger.workTarget.hasOwnProperty('entityType')
            ? // eslint-disable-next-line max-len
              `(${trigger.workTarget.ids.length} ${trigger.workTarget.entityType.toLowerCase()}${
                trigger.workTarget.ids.length === 1 ? '' : 's'
              })`
            : '';
        const currentSchedule = {
          id: pastSchedule.getId(),
          calendarId: `${trigger.workType}-past`,
          // eslint-disable-next-line max-len
          title: `${displayName} ${targets} - ${status}`,
          category: 'time',
          dueDateClass: '',
          start: startTime,
          end: endTime,
          isReadOnly: true,
          isVisible: true,
          recurrenceRule: recurringRule,
          body: mainSchedule[pastSchedule.getTriggerTypeId()].id,
        };
        if (!this.calendarInst.getSchedule(currentSchedule.id, currentSchedule.calendarId)) {
          this.calendarInst.createSchedules([currentSchedule], true);
        } else {
          this.calendarInst.updateSchedule(
            currentSchedule.id,
            currentSchedule.calendarId,
            currentSchedule,
            true
          );
        }
      });
    }

    if (this.state.workType.value === 'all') {
      Object.keys(calendarCardTheme).forEach((calendarId) => {
        this.calendarInst.toggleSchedules(calendarId, false, true);
      });
    } else {
      Object.keys(calendarCardTheme).forEach((calendarId) => {
        this.calendarInst.toggleSchedules(calendarId, true, true);
      });
      this.calendarInst.toggleSchedules(this.state.workType.value, false, true);
    }

    this.calendarInst.render(true);
  }

  removeSchedule(triggerTypeEntity) {
    this._removeSchedulesOfTriggerType(triggerTypeEntity);
  }

  updateSchedule(triggerTypeEntity) {
    this._removeSchedulesOfTriggerType(triggerTypeEntity);

    this.props.getPastSchedulesStart([triggerTypeEntity]);
    this.props.getFutureSchedulesStart([triggerTypeEntity]);
  }

  _removeSchedulesOfTriggerType(triggerTypeEntity) {
    if (!_.isEmpty(this.props.pastSchedulesFeed)) {
      this.props.pastSchedulesFeed.forEach((pastSchedule) => {
        if (pastSchedule.getTriggerTypeId() === triggerTypeEntity.getId()) {
          this.calendarInst.deleteSchedule(
            pastSchedule.getId(),
            `${triggerTypeEntity.workType}-past`
          );
        }
      });
    }

    if (!_.isEmpty(this.props.futureSchedulesFeed)) {
      this.props.futureSchedulesFeed.forEach((futureSchedule) => {
        if (futureSchedule.getTriggerTypeId() === triggerTypeEntity.getId()) {
          this.calendarInst.deleteSchedule(
            futureSchedule.getId(),
            triggerTypeEntity.workType,
            true
          );
        }
      });
    }

    this.calendarInst.render();
  }

  addSchedule(triggerTypeEntity) {
    this.props.getPastSchedulesStart([triggerTypeEntity]);
    this.props.getFutureSchedulesStart([triggerTypeEntity]);
  }

  createSchedule(scheduleFeed) {
    const scheduleObject = [];
    const calendarObject = [];

    Object.keys(calendarCardTheme).forEach((calTheme) => {
      calendarObject.push({
        id: calTheme,
        name: calendarCardTheme[calTheme].name,
        color: calendarCardTheme[calTheme].color,
        bgColor: calendarCardTheme[calTheme].bgColor,
        dragBgColor: calendarCardTheme[calTheme].dragBgColor,
        borderColor: calendarCardTheme[calTheme].borderColor,
      });
    });

    this.calendarInst.clear();
    this.calendarInst.setCalendars(calendarObject);
    this.calendarInst.createSchedules([scheduleObject]);
    // this.calendarInst.render();

    const recurringSchedules = [];

    for (const schedule in scheduleFeed.getCache()) {
      recurringSchedules.push(scheduleFeed.getCache()[schedule]);
    }
    if (recurringSchedules.length > 0) {
      this.props.getPastSchedulesStart(recurringSchedules);
      this.props.getFutureSchedulesStart(recurringSchedules);
    }

    if (this.state.workType.value === 'all') {
      Object.keys(calendarCardTheme).forEach((calendarId) => {
        this.calendarInst.toggleSchedules(calendarId, false, true);
      });
    } else {
      Object.keys(calendarCardTheme).forEach((calendarId) => {
        this.calendarInst.toggleSchedules(calendarId, true, true);
      });
      this.calendarInst.toggleSchedules(this.state.workType.value, false, true);
    }
  }

  editClicked(e) {
    if (e.target && e.target.classList.contains('btn-go-to')) {
      e.preventDefault();
      this.shutdown();
      this.componentShutDown = true;
      // eslint-disable-next-line no-restricted-globals
      location.href = e.target.href;
    }
  }

  componentDidMount() {
    document.addEventListener('click', (this.editClicked = this.editClicked.bind(this)));

    this.isScheduleMounted = true;

    this.moveNavigation.current.addEventListener('click', this.onClickNavi.bind(this));
    this.calendarInst = new TuiCalendar(this.rootEl.current, {
      ...calendarOptions,
      usageStatistics: false,
      view: this.state.viewType.value || viewType[0].value,
      defaultView: this.state.viewType.value || viewType[0].value,
      useDetailPopup: true,
      useCreationPopup: true,
      theme: CUSTOM_THEME,
      bgColor: '#000',
      template: {
        monthDayname(dayname) {
          return `<span class="calendar-week-dayname-name">${dayname.label}</span>`;
        },
        popupDetailDate: (isAllDay, start, end) => {
          start = start._date;
          end = end._date;
          const isSameDate = moment(start).isSame(end);
          if (isAllDay) {
            return `Scheduled Date: ${moment(start).format('DD/MM/YYYY')} +
                        ${isSameDate ? '' : ` - ${moment(end).format('DD/MM/YYYY')}`}`;
          }
          if (start === end) {
            return `${this.toLocaleDateTimeString(start)}`;
          }
          return `${this.toLocaleDateTimeString(start)} -
                    ${this.toLocaleDateTimeString(end)}`;
        },
        popupDetailBody: (schedule) => {
          const anchor = document.createElement('a');
          const routerObj = {
            selection: [schedule.body],
            openEditor: true,
          };
          anchor.classList.add('btn-go-to');
          // eslint-disable-next-line max-len
          // eslint-disable-next-line no-restricted-globals
          anchor.href = this.steve.router.buildUrl(location.origin, {
            app: 'GameConsole',
            s: 'GameCenter',
            sln: 'WorkTriggers',
            rd: routerObj,
          });
          anchor.text = 'View event';
          return anchor.outerHTML;
        },
        popupDetailRepeat(schedule) {
          return `${schedule.recurrenceRule}`;
        },
        monthGridHeader: (dayModel) => {
          const date = parseInt(dayModel.date.split('-')[2], 10);
          const classNames = ['tui-full-calendar-weekday-grid-date '];
          if (dayModel.isToday) {
            classNames.push('tui-full-calendar-weekday-grid-date-decorator');
          }
          return `<span class='${classNames.join(' ')}'>${date}</span>`;
        },
        weekDayname(model) {
          return `<span class="tui-full-calendar-dayname-name week-day-name">${model.dayName}</span>
                        <span class="spaces">&nbsp;&nbsp;</span>
                        <span class="tui-full-calendar-dayname-date week-date">${model.date}</span>`;
        },
        timegridCurrentTime(timezone) {
          const templates = [];
          if (timezone.dateDifference) {
            templates.push(`[${timezone.dateDifferenceSign} ${timezone.dateDifference}]<br>`);
          }
          templates.push(moment(timezone.hourmarker.toUTCString()).format('h:mm a'));
          return templates.join('');
        },
        monthGridHeaderExceed: (hiddenSchedules) => {
          if (this.calendarInst) {
            const monthDay = this.calendarInst._layout.container.querySelector(
              '.tui-full-calendar-near-month-day'
            );

            if (!monthDay || (monthDay && monthDay.clientWidth > 100)) {
              return `<span class="tui-full-calendar-weekday-grid-more-schedules">
                                ${hiddenSchedules} more
                                </span>`;
            }
          }
          return `<span class="tui-full-calendar-weekday-grid-more-schedules smaller-font">
                        ${hiddenSchedules}<br/>more
                        </span>`;
        },
      },
    });

    this.setRenderRangeText();
    if (this.isScheduleMounted) {
      this.props.getSchedulesStart({});
    }
  }

  componentWillUnmount() {
    this.shutdown();
  }

  shutdown() {
    if (!this.componentShutDown) {
      this.unregisterEntityChangeFeedListeners();
      this.isScheduleMounted = false;
      this.calendarInst = undefined;
      if (
        this.props.schedulesFeed.hasOwnProperty('_cache') &&
        Object.keys(this.props.schedulesFeed).length &&
        Object.keys(this.props.schedulesFeed.getCache()).length
      ) {
        this.props.schedulesFeed.shutdown();
      }
    }
  }

  toggleSettingsModal = (e) => {
    e.stopPropagation();
    this.setState({
      isSettingsModalShown: !this.state.isSettingsModalShown,
    });
  };

  handleSelectOptionChange = (field, props) => (value) => {
    return props.setFieldValue(field, value);
  };

  toggleCalendarViews() {
    if (this.state.workType.value === 'all') {
      Object.keys(calendarCardTheme).forEach((calendarId) => {
        this.calendarInst.toggleSchedules(calendarId, false, true);
      });
    } else {
      Object.keys(calendarCardTheme).forEach((calendarId) => {
        this.calendarInst.toggleSchedules(calendarId, true, true);
      });
      this.calendarInst.toggleSchedules(this.state.workType.value, false, true);
      this.calendarInst.toggleSchedules(`${this.state.workType.value}-past`, false, true);
    }
  }

  handleViewTypeChange = (type) => {
    this.setState(
      {
        ...this.state,
        viewType: type,
        workType: this.state.workType,
      },
      () => {
        const newData = {
          ...this.props.data,
          config: {
            ...this.props.data.config,
            workType: this.state.workType,
            viewType: this.state.viewType,
          },
          title: this.props.data.title,
          viewType: this.state.viewType,
        };

        this.props.onUpdate(newData);

        this.setRenderRangeText();

        steveDataStorage('dashboards', 'running', true).set(
          type,
          `schedulePref-${this.props.data.id}`
        );
        this.viewTypePref = steveDataStorage('dashboards', 'running', true).get(
          `schedulePref-${this.props.data.id}`
        );
      }
    );
    this.calendarInst.changeView(type.value, true);
  };

  handleSave = (data) => {
    const newData = {
      ...this.props.data,
      config: {
        ...data.config,
        workType: data.config.workType,
        viewType: this.viewTypePref || data.config.viewType,
      },
      title: data.title,
    };
    let updateFeed = false;
    if (data.config.workType.value !== this.state.workType.value) {
      updateFeed = true;
    }

    this.setState(
      {
        isSettingsModalShown: false,
        workType: data.config.workType,
        viewType: this.viewTypePref || data.config.viewType,
      },
      () => {
        this.props.onUpdate(newData);
        this.setRenderRangeText();

        if (updateFeed) {
          this.toggleCalendarViews();
        }
      }
    );
  };

  currentCalendarDate = (format) => {
    const cal = this.calendarInst;
    const currentDate = moment([
      cal.getDate().getFullYear(),
      cal.getDate().getMonth(),
      cal.getDate().getDate(),
    ]);
    return currentDate.format(format);
  };

  setRenderRangeText = () => {
    const cal = this.calendarInst;
    const renderRange = this.renderRange.current;
    const options = cal.getOptions();
    const viewName = cal.getViewName();

    const html = [];
    if (viewName === 'day') {
      html.push(this.currentCalendarDate('dddd, MMM D, YYYY'));
    } else if (
      viewName === 'month' &&
      (!options.month.visibleWeeksCount || options.month.visibleWeeksCount > 4)
    ) {
      html.push(this.currentCalendarDate('MMMM YYYY'));
    } else if (cal.getDateRangeStart().getMonth() !== cal.getDateRangeEnd().getMonth()) {
      html.push(moment(cal.getDateRangeStart().getTime()).format('MMM YYYY'));
      html.push(' - ');
      html.push(moment(cal.getDateRangeEnd().getTime()).format('MMM YYYY'));
    } else {
      html.push(this.currentCalendarDate('MMMM YYYY'));
    }
    renderRange.innerHTML = html.join('');
  };

  getDataAction = (target) => {
    return target.dataset ? target.dataset.action : target.getAttribute('data-action');
  };

  onClickNavi = (e) => {
    const cal = this.calendarInst;
    const action = this.getDataAction(e.target);

    switch (action) {
      case 'move-prev':
        cal.prev();
        break;
      case 'move-next':
        cal.next();
        break;
      case 'move-today':
        cal.today();
        break;
      default:
        return;
    }

    this.setRenderRangeText();
  };

  toLocaleDateTimeString = (val) => {
    const d = new Date(val);
    if (Object.prototype.toString.call(d) === '[object Date]' && !isNaN(d.getTime())) {
      return `${d.toLocaleDateString()} ${d.toLocaleTimeString()}`;
    }
    return '';
  };

  render() {
    return (
      <>
        <div className="glu-dashboard-card glu-content">
          {this.props.isFetchingSchedules && <Loader />}
          <div className="glu-content__header">
            {this.props.isEditAllowed && (
              <div className="glu-flex-shrink">
                <IconButton className="glu-icon__draggable cursor-move" icon="drag" />
              </div>
            )}
            <TextOverflowTooltip
              title={this.props.data.title}
              height={this.props.height}
              width={this.props.width}
              test="data chart"
              renderChildren={(ref) => (
                <div className="glu-flex-grow">
                  <div className="glu-page__title glu-widget-title" ref={ref}>
                    {this.props.data.title}
                  </div>
                </div>
              )}
            />
            <div className="glu-flex-row">
              {this.state.url && (
                <>
                  <div className="glu-flex-shrink">
                    <IconButton icon="exit-from-the-app" onClick={this.openInNewWindow} />
                  </div>
                  <div className="glu-flex-shrink">
                    <IconButton icon="refresh" onClick={this.handleRefreshIframe} />
                  </div>
                </>
              )}
              {this.props.isEditAllowed && (
                <WidgetOptions
                  showWidgetInfo={this.props.showWidgetInfo(this.props.data)}
                  openConfiguration={this.toggleSettingsModal}
                  onRemove={this.props.onRemove(this.props.data)}
                  onClone={this.props.onClone(this.props.data)}
                />
              )}
            </div>
          </div>
          <div className="glu-content__body">
            <div
              className={`glu-content__section glu-content__scheduler
                            glu-content__separator glu-content__${this.state.viewType.value}
                            ${
                              this.props.isFetchingSchedules || this.props.schedulesError
                                ? 'widget-hidden'
                                : ''
                            }
                        `}
            >
              <div className="menu">
                <span ref={this.moveNavigation}>
                  <button
                    type="button"
                    className="btn btn-default btn-sm move-day"
                    data-action="move-prev"
                  >
                    <span className="g-icon-previous" data-action="move-prev" />
                  </button>
                  <button
                    type="button"
                    className="btn btn-default btn-sm move-day"
                    data-action="move-next"
                  >
                    <span className="g-icon-next" data-action="move-next" />
                  </button>
                </span>
                <div className="range-container">
                  <span ref={this.renderRange} className="render-range" />
                  {/* <span className="cal-type">{this.state.viewType.label}</span> */}
                  <span className="time-zone">
                    {/* eslint-disable-next-line max-len */}
                    {`${
                      new Date().toLocaleTimeString('en-us', {timeZoneName: 'short'}).split(' ')[2]
                    }(${
                      /.*\s(.+)/.exec(
                        new Date().toLocaleDateString(navigator.language, {timeZoneName: 'short'})
                      )[1]
                    })`}
                  </span>
                </div>
                <div className="type-dropdown">
                  <Select
                    className="glu-select"
                    classNamePrefix="react-select"
                    closeMenuOnSelect
                    placeholder="Select"
                    options={viewType}
                    onChange={this.handleViewTypeChange.bind(this)}
                    value={this.state.viewType}
                    NoOptionsMessage
                  />
                </div>
              </div>
              <div className="calendar-container" ref={this.rootEl} />
            </div>
            {this.props.schedulesError && (
              <WidgetEmpty
                isEditAllowed={this.props.isEditAllowed}
                showSettingsModal={this.toggleSettingsModal}
                text={this.props.schedulesError || 'Something went wrong.'}
              />
            )}
          </div>
        </div>
        {this.state.isSettingsModalShown && (
          <ModalDefault isOpen={this.state.isSettingsModalShown}>
            <div className="glu-modal-content">
              <div className="glu-modal__header">
                <div className="glu-modal__title glu-flex-grow">{this.props.data.title}</div>
                <div className="glu-flex-shrink">
                  <button
                    aria-label="close"
                    type="button"
                    className="glu-btn-link g-icon g-icon-close"
                    onClick={this.toggleSettingsModal}
                  />
                </div>
              </div>
              <Formik
                initialValues={{
                  title: this.props.data.title,
                  config: {
                    ...this.props.data.config,
                    workType: this.props.data.config.workType || workType[0],
                    viewType: this.viewTypePref || this.props.data.config.viewType || viewType[0],
                  },
                }}
                onSubmit={this.handleSave}
              >
                {(props) => {
                  return (
                    <Form>
                      <div className="glu-modal__body">
                        <div className="glu-content__section">
                          <div className="glu-form-row">
                            <div className="glu-label">Widget Title</div>
                            <Field
                              as={Input}
                              autoFocus
                              name="title"
                              className="glu-form-input-pad"
                              onChange={props.handleChange('title')}
                              validate={schemaValidate([required(), minLength(), maxLength(30)])}
                              invalid={props.errors.title && props.touched.title}
                            />
                            <ErrorMessage name="title" component={FormErrorMessage} />
                          </div>
                          <div className="glu-form-row">
                            <div className="glu-label">Work type</div>
                            <Field
                              as={Select}
                              name="workType"
                              options={workType}
                              isSearchable={false}
                              value={props.values.config.workType || workType[0]}
                              onChange={this.handleSelectOptionChange('config.workType', props)}
                              className="glu-select glu-form-input-pad"
                              classNamePrefix="react-select"
                            />
                          </div>
                        </div>
                      </div>
                      <footer className="glu-modal__footer">
                        <div className="glu-flex-grow glu-flex-row">
                          <div className="glu-flex-grow text-right">
                            <button
                              onClick={this.toggleSettingsModal}
                              className="glu-btn glu-btn--secondary"
                              type="button"
                            >
                              Cancel
                            </button>
                          </div>
                          <div className="glu-flex-shrink">
                            <button type="submit" className="glu-btn glu-btn--primary">
                              Save
                            </button>
                          </div>
                        </div>
                      </footer>
                    </Form>
                  );
                }}
              </Formik>
            </div>
          </ModalDefault>
        )}
      </>
    );
  }
}

ScheduledActivityWidget.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  getSchedulesStart: PropTypes.func.isRequired,
  getFutureSchedulesStart: PropTypes.func.isRequired,
  getPastSchedulesStart: PropTypes.func.isRequired,
  isEditAllowed: PropTypes.bool,
  onRemove: PropTypes.func,
  onUpdate: PropTypes.func,
  showWidgetInfo: PropTypes.func,
  onClone: PropTypes.func,
  schedulesFeed: PropTypes.objectOf(PropTypes.any),
  futureSchedulesFeed: PropTypes.arrayOf(PropTypes.any),
  pastSchedulesFeed: PropTypes.arrayOf(PropTypes.any),
  isFetchingSchedules: PropTypes.bool.isRequired,
};

ScheduledActivityWidget.defaultProps = {
  isEditAllowed: false,
  onRemove: undefined,
  onUpdate: undefined,
  showWidgetInfo: undefined,
  onClone: undefined,
  schedulesFeed: {},
  futureSchedulesFeed: [],
  pastSchedulesFeed: [],
};

function mapStateToProps(state) {
  return {
    schedulesFeed: state.dashboardReducer.schedulesFeed,
    futureSchedulesFeed: state.dashboardReducer.futureSchedulesFeed,
    pastSchedulesFeed: state.dashboardReducer.pastSchedulesFeed,
    schedulesError: state.dashboardReducer.schedulesError,
    isFetchingSchedules: state.dashboardReducer.isFetchingSchedules,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getSchedulesStart: (query) => getSchedulesStart(dispatch, query),
    getFutureSchedulesStart: (query) => getFutureSchedulesStart(dispatch, query),
    getPastSchedulesStart: (query) => getPastSchedulesStart(dispatch, query),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withResizeDetector(ScheduledActivityWidget));
